import React from "react";
import { FormGroup, Notification, CheckTreePicker as RSuiteCheckTreePicker } from "rsuite";
import axios from "../../../../utilities/axios";
import { Placeholder } from 'rsuite';
import _ from "lodash";
const { Paragraph } = Placeholder;


export class CheckTreePickerProjectUser extends React.Component<any, {}> {
    public state = {
        isLoading: false,
        data: [],
        dataValueChange: [],
        loadValues: []
    }

    componentDidMount(): void {
        try {
            let arrayStringValues: any = [];
            if (this?.props.values.project_users) {
                if (this.props.values.project_users.includes(',')) {
                    const arrayOriginal = this.props.values.project_users.split(',');
                    arrayStringValues = arrayOriginal.map((item: any) => Number(item));
                } else {
                    arrayStringValues.push(parseInt(this.props.values.project_users))
                }
                this.setState({ loadValues: arrayStringValues })
            }
        } catch (e) {
            console.log('Error :::> ', e)
        }
        this.onStartLoading()
    }


    onStartLoading = () => {
        this.setState({ isLoading: true })
        axios.get('/api/v1/custom/checktreepicker/select')
            .then((res) => {
                var arr: any = [...res.data.items];
                // if (value) {
                //     arr = this.find(value, arr);
                //     //(arr);
                // }
                this.setState({ data: arr, loading: false });
            })
            .finally(() => {
                this.setState({ isLoading: false })
            })
    }

    onLoadingOptions = () => {
        this.setState({ isLoading: true })
        axios.get('/api/v1/custom/checktreepicker/select')
            .then((response) => {
                this.setState({ data: response.data.items })
            })
            .catch((err) => {
                Notification.info(
                    {
                        title: 'Info',
                        description: err.response.data.message
                    }
                )
            })
            .finally(() => {
                this.setState({ isLoading: false })
            })
    }

    selectUsers = (eventValue: any) => {
        let valueOnChange = [...this.state.loadValues, eventValue.value];
        if (!eventValue.check) {
            valueOnChange = valueOnChange.filter(item => item !== eventValue.value)
        }
        this.setState({ loadValues: valueOnChange });
        this.props.onChange(valueOnChange)
        // this.setState({ loadValues: valueOnChange})
    }

    onClean = () => {
        this.setState({ dataValueChange: [] });
        this.props.onChange([])
    }

    render() {
        return (
            <>
                {!this.state.isLoading ? (
                    <FormGroup
                        style={
                            {
                                paddingTop: 4
                            }
                        }
                    >
                        <label>Adm. de Projetos Envolvidos</label>
                        <div className="rs-form-control-wrapper">
                            <RSuiteCheckTreePicker
                                data={this.state.data}
                                value={this.state.loadValues}
                                // onOpen={() => this.onLoadingOptions()}
                                onSelect={(value) => this.selectUsers(value)}
                                onClean={(event) => this.onClean()}
                            />
                        </div>
                    </FormGroup>
                ) : (
                    <Paragraph />
                )}
            </>
        )
    }
}